import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import BannerSkeleton from "components/skeleton/BannerSkelaton";

import "./dynamicPage.scss";

import { getAboutUs } from "services/dynamicpage/dynamicpage";
import NotFound from "pages/notfound/Notfound";

const DynamicPage = () => {
  const { dynamicpage } = useParams();
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await getAboutUs({ path: `/${dynamicpage}` });
        if (res?.code === 200) setPageData(res.data);
        else console.error("Failed to load page content");
      } catch (err) {
        console.error("Error fetching page:", err);
      } finally {
        setLoading(false);
      }
    };
    if (dynamicpage) fetchPage();
  }, [dynamicpage]);

  if (loading) return <BannerSkeleton />;

  if (!pageData) return <NotFound />;

  return (
    <div className="info-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <h1>{pageData.PageName}</h1>
          {pageData.MetaDescription && (
            <p className="meta-description">{pageData.MetaDescription}</p>
          )}
        </div>
      </section>

      {/* Main Content */}
      <section className="description-section container">
        <div className="content">
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: pageData.Description }}
          />
        </div>
      </section>
    </div>
  );
};

export default DynamicPage;
